module.exports = __webpack_public_path__ + "img/baseStandard.d936fb59.png";